const screenWidth = window.innerWidth;

// for smooth scroll start---------
const lenis = new Lenis()
// lenis.on('scroll', (e) => {
//   console.log(e)
// })
lenis.on('scroll', ScrollTrigger.update)
gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
})
gsap.ticker.lagSmoothing(0)

// split line for heading animation----------
new SplitType('.sec-header-content-anim', {
    types: 'lines',
    lineClass: "sec-header-content-anim-line",
    tagName: "span"
});


function useSetupSplits() {
	const targets = gsap.utils.toArray(
		'.split-text, .split-text h3, .split-text h4, .split-text p, .rich-text h1, .rich-text h2, .rich-text h3, .rich-text h4'
	);
	if (screenWidth <= 1025) {
		gsap.to('.split-text', {
			duration: 1.2,
			alpha: 1,
			ease: 'power3.out',
		});
	} 
	gsap.set('.split-text', {
		alpha: 1,
	});

	targets.forEach((el) => {
		const childSplit = new SplitText(el, {
			type: 'lines',
			linesClass: 'split-child',
			reduceWhiteSpace: false,
		});

		const parentSplit = new SplitText(el, {
			type: 'lines',
			linesClass: 'split-parent',
			reduceWhiteSpace: false,
		});

		gsap.from(childSplit.lines, {
			duration: 1.2,
			alpha: 0,
			yPercent: 65,
			ease: 'expo.out',
			stagger: 0.035,
			scrollTrigger: {
				trigger: el,
				start: 'top +=100%',
				scrub: false,
				toggleActions: 'play none play none',
			},
		});
	});
};
document.addEventListener('DOMContentLoaded', function() {
	useSetupSplits();

	// Images parallax
	gsap.utils.toArray('.article-media, .article-hero').forEach(container => {
		const img = container.querySelector('img');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: container,
				scrub: true,
				pin: false,
			}
		});

		tl.fromTo(img, {
			yPercent: -20,
			ease: 'none'
		}, {
			yPercent: 20,
			ease: 'none'
		});
	});

});